import { render, staticRenderFns } from "./SaludEvent.vue?vue&type=template&id=0bbbb58c&scoped=true"
import script from "./SaludEvent.vue?vue&type=script&lang=js"
export * from "./SaludEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbb58c",
  null
  
)

export default component.exports